module.exports = __webpack_public_path__ + "static/YoClock2-5da282fe48edf874ad5ea56b74d2640d.png";